// extracted by mini-css-extract-plugin
export var entityChip = "_t2-0";
export var entityChipMissing = "_t2-1";